/**
 * A Verk bizonylat köztes tábláinak (hmifcapiverkinv, hmifcapiverkacc) státuszai. Nem az IfaceSyncStatus
 * jelentését hordozzák: 2 küldésre vár, 3 elküldve, 4 összeállítási hiba, 5 API-hiba (újraküldhető).
 */
export enum VerkInvoiceStatus {
  Pending = 2,
  Sent = 3,
  PrepareError = 4,
  ApiError = 5,
}

/** A badge háttérszíne — a két hiba-státusz egyformán piros (az IfaceSyncStatus 5-öse szürke lenne). */
export function verkInvoiceStatusColor(status: number): string {
  switch (status) {
    case VerkInvoiceStatus.Pending: return "#1976d2";
    case VerkInvoiceStatus.Sent: return "#2e7d32";
    case VerkInvoiceStatus.PrepareError:
    case VerkInvoiceStatus.ApiError: return "#d32f2f";
    default: return "#757575";
  }
}
